<div class="desktop-full-screen-overlay--flex">
  <div class="voucher-exchange-container">
    <app-form-container
      [title]="'webPos.VoucherExchange.Title' | translate"
      (onCancel)="close()"
      (onSubmit)="onConfirm()"
      [confirmDisabled]="form.invalid || form.pending"
    >
      <ng-container form-body>
        <form [formGroup]="form" class="voucher-exchange-form">

          <!-- Transfer from -->
          <div class="voucher-exchange-section">
            <h3 class="voucher-exchange-section__title">{{ 'webPos.VoucherExchange.TransferFrom' | translate }}</h3>
            <app-dropdown
              [label]="'webPos.ValuableType' | translate"
              [options]="voucherTypeOptions"
              formControlName="fromPaymentType">
            </app-dropdown>

            <!-- Nominal mode: nominal dropdown + piece count -->
            <div class="voucher-exchange-row" *ngIf="fromHasNominals">
              <app-dropdown
                class="voucher-exchange-row__item"
                [label]="'webPos.VoucherExchange.Nominal' | translate"
                [options]="fromNominalOptions"
                formControlName="fromNominal">
              </app-dropdown>
              <app-form-input
                class="voucher-exchange-row__item"
                [label]="'webPos.VoucherExchange.PieceCount' | translate"
                [placeholder]="''"
                [type]="FormInputType.Number"
                formControlName="fromPieces">
              </app-form-input>
            </div>

            <!-- Free-value mode: single value input -->
            <app-form-input
              *ngIf="form.controls.fromPaymentType.value && !fromHasNominals"
              [label]="'webPos.Value' | translate"
              [placeholder]="''"
              [type]="FormInputType.Number"
              formControlName="fromValue">
            </app-form-input>

            @if (fromAvailableAmount() !== null) {
              <div class="form-message hint">
                {{ 'webPos.AvailableValue' | translate }}: {{ fromAvailableAmount() | hcurrency : (fromSelectedPaymentType?.Currency || fallbackCurrencyCode) }}
              </div>
            }

            @if (fromAmountExceeded) {
              <div class="form-message error">
                {{ 'webPos.Errors.MaxAllowedAmountExceeded' | translate }}
              </div>
            }
          </div>

          <!-- Transfer to -->
          <div class="voucher-exchange-section">
            <h3 class="voucher-exchange-section__title">{{ 'webPos.VoucherExchange.TransferTo' | translate }}</h3>
            <app-dropdown
              [label]="'webPos.ValuableType' | translate"
              [options]="voucherTypeOptions"
              formControlName="toPaymentType">
            </app-dropdown>

            <!-- Nominal mode: nominal dropdown + piece count -->
            <div class="voucher-exchange-row" *ngIf="toHasNominals">
              <app-dropdown
                class="voucher-exchange-row__item"
                [label]="'webPos.VoucherExchange.Nominal' | translate"
                [options]="toNominalOptions"
                formControlName="toNominal">
              </app-dropdown>
              <app-form-input
                class="voucher-exchange-row__item"
                [label]="'webPos.VoucherExchange.PieceCount' | translate"
                [placeholder]="''"
                [type]="FormInputType.Number"
                formControlName="toPieces">
              </app-form-input>
            </div>

            <!-- Free-value mode: single value input -->
            <app-form-input
              *ngIf="form.controls.toPaymentType.value && !toHasNominals"
              [label]="'webPos.Value' | translate"
              [placeholder]="''"
              [type]="FormInputType.Number"
              formControlName="toValue">
            </app-form-input>

          </div>

          <!-- Value mismatch error -->
          <div class="form-message error" *ngIf="valueMismatch">
            {{ 'webPos.VoucherExchange.ValueMismatch' | translate }}
          </div>

          <!-- Note -->
          <app-form-textarea
            [label]="'webPos.Note' | translate"
            formControlName="note">
          </app-form-textarea>

        </form>
      </ng-container>
    </app-form-container>
  </div>
</div>
